var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"close_cross",attrs:{"src":require("@/assets/images/cross.svg"),"alt":"cross"},on:{"click":_vm.closeModal}})
}
var staticRenderFns = []

export { render, staticRenderFns }